import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {makeGetVisualParticipants} from '../../../store/data/contacts/participantsSelectors';
import {getTimeFormat} from '../../../store/data/preferences/preferencesSelectors';
import {getUserNamespace} from '../../../store/data/teammates/teammatesSelectors';
import {CalendarEventData} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {PopoverCalendarEventViewer} from './popoverCalendarEventViewer';

/*
 * Props.
 */

interface PopoverCalendarEventViewerContainerProps {
  calendarEventData: CalendarEventData;
}

/*
 * Selectors.
 */

function getCalendarEvent(_state: AppState, props: PopoverCalendarEventViewerContainerProps) {
  return props.calendarEventData.calendarEvent;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<PopoverCalendarEventViewerContainerProps>()(() => ({
  visualParticipants: makeGetVisualParticipants(getUserNamespace, getCalendarEvent),
  timeFormat: getTimeFormat,
}));

export const PopoverCalendarEventViewerContainer = connect(mapStateToProps)(PopoverCalendarEventViewer);
